// extracted by mini-css-extract-plugin
export default {"text-input":"styles_text-input__TQa4D","text-input--underlined":"styles_text-input--underlined__rWFFb"};